"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DateFromJson = function (value) {
    if (value === null || value === undefined || value === "") {
        return null;
    }
    if (parseInt(value, 10).toString() === value && value.length === 8) {
        var year = parseInt(value.substring(0, 4), 10);
        var month = parseInt(value.substring(4, 6), 10) - 1;
        var day = parseInt(value.substring(6), 10);
        return new Date(year, month, day);
    }
    return new Date(value);
};
exports.DateFromJson = DateFromJson;
//# sourceMappingURL=date-from-json.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/skiliko-sdk/lib/helpers/date-from-json.js
// module id = 853
// module chunks = 3